module OfficeExt {
  export class MicrosoftAjaxFactory {
    private _msAjaxError: IMsAjaxError;
    private _msAjaxString: IMsAjaxString;
    private _msAjaxDebug: IMsAjaxDebug;
    public isMsAjaxLoaded(): boolean {
      if (
        typeof Sys !== "undefined" &&
        typeof Type !== "undefined" &&
        Sys.StringBuilder &&
        typeof Sys.StringBuilder === "function" &&
        Type.registerNamespace &&
        typeof Type.registerNamespace === "function" &&
        Type.registerClass &&
        typeof Type.registerClass === "function" &&
        typeof Function._validateParams === "function" &&
        Sys.Serialization &&
        Sys.Serialization.JavaScriptSerializer &&
        typeof Sys.Serialization.JavaScriptSerializer.serialize === "function"
      ) {
        return true;
      } else {
        return false;
      }
    }
    public get msAjaxError(): IMsAjaxError {
      if (this._msAjaxError == null && this.isMsAjaxLoaded()) {
        this._msAjaxError = Error as any;
      }
      return this._msAjaxError;
    }
    public set msAjaxError(errorClass: IMsAjaxError) {
      this._msAjaxError = errorClass;
    }
    public get msAjaxString(): IMsAjaxString {
      if (this._msAjaxString == null && this.isMsAjaxLoaded()) {
        this._msAjaxString = String as any;
      }
      return this._msAjaxString;
    }
    public set msAjaxString(stringClass: IMsAjaxString) {
      this._msAjaxString = stringClass;
    }
    public get msAjaxDebug(): IMsAjaxDebug {
      if (this._msAjaxDebug == null && this.isMsAjaxLoaded()) {
        this._msAjaxDebug = Sys.Debug as any;
      }
      return this._msAjaxDebug;
    }
    public set msAjaxDebug(debugClass: IMsAjaxDebug) {
      this._msAjaxDebug = debugClass;
    }
  }
}
var OsfMsAjaxFactory = new OfficeExt.MicrosoftAjaxFactory();
